module.exports = __webpack_public_path__ + "media/images/countryrect/sealand-05a1fef6d5b0d0718fd6da35931dfd9a.svg";